const Head = ({heads}) => {
	return (
		<tr>
			{heads.map(th => <th key={th}>{th}</th>)}
		</tr>
	)
}

export default Head